import React from "react";
import {useNavigate} from "react-router-dom";

export type FilterCategory = {
    id: string
    label: string
    icon: React.ComponentType<any>
}

interface FilterProps {
    categories: FilterCategory[]
    activeFilter: string
    onFilterChange: (filterId: string) => void
}

export const Filter = ({categories, activeFilter, onFilterChange}: FilterProps) => {
    const navigate = useNavigate()

    return (
        <div className="bg-light rounded p-3 mb-3">
            <div className="d-flex align-items-center gap-2 mb-2">
                <div className="flex-shrink-0">
                    <span className="fw-bold align-self-center">Filter by:</span>
                </div>
                <div className="d-flex flex-wrap gap-2">
                    {categories.map((category) => {
                        const IconComponent = category.icon;
                        const isActive = activeFilter === category.id;
                        return (<button
                            key={category.id}
                            type="button"
                            className={`btn btn-sm ${isActive ? "btn-primary" : "btn-outline-primary"}`}
                            onClick={() => {
                                navigate("#" + category.id);
                                onFilterChange(category.id);
                            }}
                        >
                                    <span className="me-2">
                                      <IconComponent/>
                                    </span>
                            {category.label}
                        </button>);
                    })}
                </div>
            </div>
            {activeFilter !== "all" && (
                <div className="text-muted">
                    <small>
                        Showing: {categories.find(c => c.id === activeFilter)?.label} •{" "}
                        <button
                            className="btn btn-link btn-sm p-0 text-decoration-underline"
                            onClick={() => onFilterChange("all")}
                        >
                            Show all sections
                        </button>
                    </small>
                </div>
            )}
        </div>
    );
};
